var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7793 20.5C16.3021 20.5 20.7793 16.0228 20.7793 10.5C20.7793 4.97715 16.3021 0.5 10.7793 0.5C5.25645 0.5 0.779297 4.97715 0.779297 10.5C0.779297 16.0228 5.25645 20.5 10.7793 20.5ZM4.7793 5.7C4.7793 5.0382 5.3773 4.5 6.11263 4.5H15.446C16.1813 4.5 16.7793 5.0382 16.7793 5.7V11.1C16.7793 11.7618 16.1813 12.3 15.446 12.3H12.7793V11.1H15.446V5.7L6.11263 5.7V11.1H8.7793V12.3H6.11263C5.3773 12.3 4.7793 11.7618 4.7793 11.1L4.7793 5.7ZM10.1126 13.5V8.1H11.446V13.5H13.446L10.7793 16.5L8.11263 13.5H10.1126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.42c008be37c669506446ef58ff166e4e.svg";
export { ForwardRef as ReactComponent };